<template>
  <v-app>
    <Header/>
    <Sidebar/>
    <ContentArea>
      <ButtonBar>
        <v-text-field v-model="filter" append-icon="search" :placeholder="$t('filter')" class="filterInput" v-if="!currentOrganization"/>
        <v-btn @click="createNewOrganization" class="bw-8" v-if="!currentOrganization">{{ $t('pages.organization.button.create') }}</v-btn>
        <v-btn @click="saveOrganization" :disabled="saveButtonDisabled" class="bw-3" v-if="currentOrganization">{{ $t('button.save') }}</v-btn>
        <v-btn v-if="canDelete" @click="confirmDeleteDialog = true" class="bw-3">{{ $t('button.delete') }}</v-btn>
        <v-btn @click="closeOrganization" class="bw-3" v-if="currentOrganization">{{ $t('button.close') }}</v-btn>
      </ButtonBar>
      <v-container fluid py-2 px-3 v-if="!currentOrganization" >
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex class="tableContainer">
            <v-data-table :headers="tableHeaders" :items="organizations" :search="filter" hide-default-footer>
              <template v-slot:item="props">
                <tr @click="selectRow(props.item)" class="selectable">
                  <td class="text-xs-left" style="white-space: nowrap;">{{ props.item.name }}</td>
                  <td class="text-xs-left" style="white-space: nowrap;">{{ props.item.domainName }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
      <Panel :title="$t('pages.organization.edit.header.' + (currentOrganization.id ? 'update' : 'create'))" v-if="currentOrganization">
        <PanelColumn>
          <v-flex xs12 sm4 lg2 style="height: 35px;">
            <v-label>{{ $t('pages.organization.edit.fields.name') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
            <TextField v-model="currentOrganization.name" max-width="300"/>
          </v-flex>

          <v-flex xs12 sm4 lg2 style="height: 35px;">
            <v-label>{{ $t('pages.organization.edit.fields.domainName') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
            <TextField v-model="currentOrganization.domainName" max-width="300"/>
          </v-flex>
          <div style="height: 100px"/>
        </PanelColumn>
      </Panel>
    </ContentArea>
    <Footer/>

    <v-dialog v-model="confirmDeleteDialog" persistent width="350">
      <v-card pa-5>
        <v-card-title class="headline">{{ $t('pages.organization.dialog.delete.header') }}</v-card-title>
        <v-card-text v-if="currentOrganization" style="padding-top: 20px;">
          {{ $t('pages.organization.dialog.delete.message', { name: currentOrganization.name }) }}
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="this.delete">{{ $t('button.yes') }}</v-btn>
          <v-btn @click="confirmDeleteDialog = false">{{ $t('button.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import ButtonBar from '../components/ButtonBar'
import ContentArea from '../components/ContentArea'
import Panel from '../components/Panel'
import PanelColumn from '../components/PanelColumn'
import TextField from '../components/TextField'
import axios from 'axios'

export default {
  name: 'Organizations',
  components: { Header, Sidebar, Footer, ContentArea, ButtonBar, Panel, PanelColumn, TextField },
  data () {
    return {
      filter: null,
      organizations: [],
      currentOrganization: null,
      confirmDeleteDialog: false
    }
  },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', { key: 'organizations' })
    this.loadOrganizations()
  },
  computed: {
    tableHeaders: function () {
      let headers = [
        { text: this.$t('pages.organization.table.columns.name'), value: 'name', sortable: true },
        { text: this.$t('pages.organization.table.columns.domainName'), value: 'domainName', sortable: true }
      ]
      return headers
    },
    canDelete: function () {
      return this.currentOrganization && this.currentOrganization.id
    },
    saveButtonDisabled: function () {
      return !this.currentOrganization || this.currentOrganization.name.trim() === ''
    }
  },
  methods: {
    loadOrganizations () {
      axios.get('/backend/ui/organization')
        .then(response => {
          this.organizations = response.data
        })
    },
    createNewOrganization () {
      this.currentOrganization = {
        id: null,
        name: ''
      }
    },
    saveOrganization () {
      axios.post('/backend/ui/organization', this.currentOrganization)
        .then(response => {
          this.loadOrganizations()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.currentOrganization = null
    },
    delete () {
      axios.delete('/backend/ui/organization/' + this.currentOrganization.id)
        .then(response => {
          this.loadOrganizations()
          this.currentOrganization = null
          this.confirmDeleteDialog = false
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
    },
    closeOrganization () {
      this.currentOrganization = null
    },
    selectRow (organization) {
      this.currentOrganization = organization
    }
  }
}
</script>

<style scoped>
  .organizationTable tbody tr td {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Organizations.vue